<template>
  <div class="bg-phone">
    <guest-header />
    <div class="landing">
      <div class="container">
        <div class="auth-card">
          <div class="card">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <guest-footer />
  </div>
</template>

<script>
    import GuestHeader from "@/components/Guest/Header.vue";
    import GuestFooter from "@/components/Guest/Footer.vue";

    export default {
        components: {
            GuestHeader, GuestFooter
        },
    }
</script>

